import { Component, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '../../../shared/services/globals.service';
import { BaseGridUIComponent } from '../../../shared/base-components/base-grid-ui.component';
import { StatusHistoryBus } from '../../models/StatusHistoryBus';
import { CommonFunctions } from '../../static/common-functions';
import { MSFilterClass } from '../../classes/filters/MSFilterClass';
import { MSCLFilterClass } from '../../classes/filters/MSCLFilterClass';

@Component({
    selector: 'status-history',
    templateUrl: './status-history.component.html',
    styleUrls: ['./status-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class StatusHistoryComponent extends BaseGridUIComponent<StatusHistoryBus, null, null>  {

  statusNameFC: MSFilterClass = new MSFilterClass('statusName');
  statusNameCF: MSCLFilterClass;
  constructor(globals: GlobalsService) {
    super(globals);
  }
  statusNames: string[];
  processGridData() {
    this.statusNameCF = new MSCLFilterClass('statusName', 'statusName', this.gridData);
    let tempData: any[] = _.uniq(_.map(this.gridData, 'statusName'));
    this.statusNames = tempData;
    if (CommonFunctions.hasArrayValue(tempData)) {
      this.statusNames = tempData.sort();
    }
  }
}
